// Plan configurations for both basic and advanced pricing modes
export const plans = [
  {
    id: 'freelance',
    name: 'Freelance',
    priceMonthly: 80,
    priceYearly: 800,
    maxSocialAccounts: 5,
    maxUsers: 1,
    maxSources: 5,
    features: {
      native: false,
      planification: false,
      moderation: false,
      reporting: false,
      collaboration: false
    }
  },
  {
    id: 'starter',
    name: 'Starter',
    priceMonthly: 170,
    priceYearly: 1700,
    maxSocialAccounts: 10,
    maxUsers: 5,
    maxSources: 10,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true
    }
  },
  {
    id: 'standard',
    name: 'Standard',
    priceMonthly: 270,
    priceYearly: 2700,
    maxSocialAccounts: 60,
    maxUsers: 50,
    maxSources: 60,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true
    }
  },
  {
    id: 'premium',
    name: 'Premium',
    priceMonthly: 600,
    priceYearly: 6000,
    maxSocialAccounts: 250,
    maxUsers: 200,
    maxSources: 250,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true
    }
  },
  {
    id: 'custom',
    name: 'dash.plan.card.custom.name',
    priceMonthly: null,
    priceYearly: null,
    maxSocialAccounts: 251,
    maxUsers: 201,
    maxSources: 251,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true
    }
  }
]

// Plans available in basic mode (without freelance)
export const plansBasic = plans.filter(plan => plan.id !== 'freelance')

// Features labels for display (i18n keys, translated in ResultCard.vue)
export const featureLabels = {
  native: 'dash.plan.card.feature.native',
  planification: 'dash.plan.card.feature.planification',
  moderation: 'dash.plan.card.feature.moderation',
  reporting: 'dash.plan.card.feature.reporting',
  collaboration: 'dash.plan.card.feature.collaboration'
}

export default plans
